import PackageSearchForm from './packages/PackageSearchForm';
import FlightSearchForm from './flights/FlightSearchForm';
import HotelSearchForm from './hotels/HotelSearchForm';
import { RealSearcherId, SearcherFormComponent } from './types';

/**
 * Searcher id → form component. Ids missing here have no form at all, and the
 * hero hides their tab.
 *
 * Importing this module pulls every form in; import `./types` instead when all
 * you need is to know whether a searcher is offered.
 */
export const SEARCHER_FORM_REGISTRY: Partial<Record<RealSearcherId, SearcherFormComponent>> = {
  hoteles: HotelSearchForm,
  paquetes: PackageSearchForm,
  vuelos: FlightSearchForm,
};

export function getSearcherForm(id: string): SearcherFormComponent | null {
  return SEARCHER_FORM_REGISTRY[id as RealSearcherId] ?? null;
}
